import { ListingBuyerModel } from '@steelbuy/ts-shared';

import { ListingBuyerEntityData } from './ListingBuyerEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useListingBuyerEntityData = () => useEntityData<ListingBuyerModel>(ListingBuyerEntityData);
